var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from 'vue-property-decorator';
import ServiceInterfaceService from '../../../api/ServiceInterfaceService';
import { Loading } from 'element-ui';
import VueDialog from "../../../interface/IVueDialog";
import ApplyClientsDialog from '../../printconfig/components/ApplyClientsDialog';
import RechargeDialog from '../components/RechargeDialog';
var EditDialog = (function (_super) {
    __extends(EditDialog, _super);
    function EditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ocrData = {
            "api_type": 1,
            "name": "OCR发票识别",
            "dsec": "在上传发票后将会提取发票的开票信息，与对账单客户的发票业务数据进行对比，避免发票上传错误。",
            "status": 0,
            "total_amount": 0,
            "business_num": 0,
            "business_status_group": ["", "", ""],
        };
        _this.invoiceData = {
            "api_type": 2,
            "name": "发票验真",
            "dsec": "在上传发票后将会对接税务系统验证发票的真伪，避免无效发票上传。需开启OCR发票识别后才可进行验证。",
            "status": 0,
            "total_amount": 0,
            "business_num": 0,
            "business_status_group": ["", "", ""],
        };
        _this.clientStatus = [
            { label: '全部合作状态', value: '0' },
            { label: '已合作', value: '1' },
            { label: '已暂停', value: '2' },
            { label: '已结束', value: '3' }
        ];
        return _this;
    }
    EditDialog.prototype.created = function () {
        this.service = ServiceInterfaceService.getInstance();
    };
    EditDialog.prototype.mounted = function () {
        this.serviceInfo();
    };
    EditDialog.prototype.serviceInfo = function () {
        var _this = this;
        this.service.serviceInfo().then(function (res) {
            var data = res.data.data;
            _this.ocrData = data[0] ? data[0] : _this.ocrData;
            _this.invoiceData = data[1] ? data[1] : _this.invoiceData;
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    EditDialog.prototype.confirmCloseOcr = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.$confirm('关闭后将无法进行发票验真').then(function () {
                resolve(true);
            }).catch(function () {
                resolve(false);
            });
        });
    };
    EditDialog.prototype.changeStatus = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var confirm, params;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(name == 'ocrData')) return [3, 2];
                        if (!(this[name].status == 0 && this.invoiceData.status == 1)) return [3, 2];
                        this[name].status = 1;
                        return [4, this.confirmCloseOcr()];
                    case 1:
                        confirm = _a.sent();
                        console.log('changeStatus>>>', name, confirm);
                        if (!confirm) {
                            return [2];
                        }
                        this[name].status = 0;
                        this.invoiceData.status = 0;
                        this.changeStatus('invoiceData');
                        _a.label = 2;
                    case 2:
                        if (name == 'invoiceData') {
                            if (this[name].status == 1 && this.ocrData.status == 0) {
                                this.$message.error('请先启用发票OCR识别');
                                this.invoiceData.status = 0;
                                return [2];
                            }
                        }
                        params = {
                            api_type: this[name].api_type,
                            status: this[name].status
                        };
                        this.service.serviceSetting(params).then(function (res) {
                            _this.$message.success(res.data.msg);
                        }).catch(function (err) {
                            _this.$message.error(err.message);
                        });
                        return [2];
                }
            });
        });
    };
    EditDialog.prototype.setBusiness = function (name) {
        var _this = this;
        var apiType = this[name].api_type;
        var statusMap = this[name].business_status_group || ['', '', ''];
        var map = {
            1: (statusMap[0] || '').split(',').filter(Boolean).map(Number),
            2: (statusMap[1] || '').split(',').filter(Boolean).map(Number),
            3: (statusMap[2] || '').split(',').filter(Boolean).map(Number)
        };
        this.service.getBusiness({ api_type: apiType }).then(function (res) {
            var data = res.data.data;
            var dialog = _this.$dialog(ApplyClientsDialog, {
                data: {
                    supplier_to_business_ids: data.supplier_to_business_ids,
                    group_ids: data.group_ids,
                    clientStatusSelectedMap: map,
                    clientStatus: _this.clientStatus,
                    requiredChooseNum: false,
                }
            }, {
                title: "选择客户",
                width: 640,
                height: 530
            });
            dialog.instance.$on("submit", function (res) {
                var loadingInstance = Loading.service({ fullscreen: true });
                var business_info = res.business_info;
                var group_id = business_info.filter(function (item) { return item.is_set_group == 1; }).map(function (item) {
                    if (item.is_set_group == 1) {
                        return item.group_id;
                    }
                });
                var supplier_to_business_ids = res.supplier_to_business_ids;
                var params = {
                    api_type: apiType,
                    supplier_to_business_ids: supplier_to_business_ids.join(','),
                    group_ids: group_id.join(','),
                };
                _this.service.apply(params).then(function (res) {
                    if (res.data.success) {
                        _this.serviceInfo();
                        loadingInstance.close();
                        _this.$message.success(res.data.msg);
                    }
                    else {
                        loadingInstance.close();
                        _this.$message.error(res.data.msg);
                    }
                });
            });
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    EditDialog.prototype.recharge = function (name) {
        var _this = this;
        var apiType = this[name].api_type;
        var dialog = this.$dialog(RechargeDialog, {
            data: {
                api_type: apiType
            }
        }, {
            title: "服务充值",
            width: 610,
            height: 500
        });
        dialog.instance.$on("paySuccessEdit", function (res) {
            _this.serviceInfo();
        });
    };
    EditDialog.prototype.close = function () {
        this.$closeDialog();
    };
    EditDialog.prototype.confirm = function () {
        this.$closeDialog();
    };
    EditDialog = __decorate([
        Component
    ], EditDialog);
    return EditDialog;
}(VueDialog));
export default EditDialog;
